import { DataType, utils as dataUtils } from '@easydata/core';
import { Expression } from './expression';
import { QueryChangePart, QueryChangeAction } from './query_events';
/** Represents sorting direction. */
export var SortDirection;
(function (SortDirection) {
    /** No sorting. */
    SortDirection[SortDirection["None"] = 0] = "None";
    /** Ascending order. */
    SortDirection[SortDirection["Ascending"] = 1] = "Ascending";
    /** Descending order. */
    SortDirection[SortDirection["Descending"] = 2] = "Descending";
})(SortDirection || (SortDirection = {}));
/**
 * Represents some column which will be queried
 */
var QueryColumn = /** @class */ (function () {
    /** the default constructor. */
    function QueryColumn(query, justsorted) {
        if (justsorted === void 0) { justsorted = false; }
        this.query = query;
        this.justsorted = justsorted;
        /** Column is enabled */
        this.enabled = true;
        /** The parameters associated with this column */
        this.params = [];
        this._isHidden = false;
        this._id = dataUtils.generateId('col');
        this.caption = '';
        this.sorting = SortDirection.None;
        this.sortIndex = -1;
        this.expr = new Expression(this);
        this.blockId = '';
    }
    Object.defineProperty(QueryColumn.prototype, "id", {
        get: function () {
            return this._id;
        },
        enumerable: true,
        configurable: true
    });
    QueryColumn.prototype.getModel = function () {
        return this.query.getModel();
    };
    QueryColumn.prototype.getQuery = function () {
        return this.query;
    };
    /** Indicates whether this column is read-only */
    QueryColumn.prototype.isReadOnly = function () {
        return false;
    };
    /** Indicates whether this column is just-sorted */
    QueryColumn.prototype.isJustSorted = function () {
        return this.justsorted;
    };
    QueryColumn.prototype.setReadOnly = function (value) {
        //do nothing. Read-only columns are not supported here
    };
    /** Indicates whether this column is invisible */
    QueryColumn.prototype.isHidden = function () {
        return this._isHidden;
    };
    QueryColumn.prototype.setHidden = function (value) {
        this._isHidden = value;
    };
    QueryColumn.prototype.getDataType = function () {
        if (this.expr.dataType === DataType.Unknown) {
            var attrId = null;
            if (this.expr.func) {
                if (this.expr.func == "COUNT" || this.expr.func == "CNTDST")
                    return DataType.Int64;
                attrId = this.expr.args[0].value;
            }
            else {
                attrId = this.expr.value;
            }
            var attr = this.query.getModel()
                .getAttributeById(attrId);
            if (attr)
                return attr.dataType;
        }
        return this.expr.dataType;
    };
    /**
      * Loads column from its JSON representation object.
      * @param model The Data Model.
      * @param colData The JSON representation object.
      */
    QueryColumn.prototype.loadFromData = function (model, colData) {
        if (colData) {
            if (colData.id) {
                this._id = colData.id;
            }
            this.caption = colData.cptn;
            if (typeof colData.srt !== 'undefined') {
                this.sorting = colData.srt;
                this.sortIndex = (typeof colData.srtidx !== 'undefined')
                    ? colData.srtidx
                    : -1;
            }
            if (colData.enabled === false) {
                this.enabled = colData.enabled;
            }
            this.expr.loadFromData(model, colData.expr);
            this.blockId = colData.blockId;
            this.displayFormat = colData.dfmt;
            this.groupFooterColumnTemlate = colData.gfct;
            if (colData.hidden) {
                this.setHidden(true);
            }
        }
    };
    /**
     * Saves the column to a data transfer object (ready for sending to the server-side) .
     * @returns An plain object that represents the column.
     */
    QueryColumn.prototype.saveToData = function () {
        var obj = {};
        obj.id = this._id;
        if (typeof this.caption !== 'undefined') {
            obj.cptn = this.caption;
        }
        if (typeof this.sorting !== 'undefined' && this.sorting != SortDirection.None) {
            obj.srt = this.sorting;
            obj.srtidx = this.sortIndex;
        }
        obj.expr = this.expr.saveToData();
        if (this.blockId) {
            obj.blockId = this.blockId;
        }
        if (this.enabled === false) {
            obj.enabled = this.enabled;
        }
        obj.dfmt = this.displayFormat;
        obj.gfct = this.groupFooterColumnTemlate;
        if (this.isHidden()) {
            obj.hidden = true;
        }
        return obj;
    };
    QueryColumn.prototype.fireChangedEvent = function () {
        this.query.fireChangedEvent({
            part: (this.justsorted)
                ? QueryChangePart.SortingColumns
                : QueryChangePart.Columns,
            action: QueryChangeAction.Modify,
            changee: this
        });
    };
    QueryColumn.prototype.getExpressionIndex = function (expr) {
        return 0;
    };
    QueryColumn.prototype.expressionChanged = function (expr, oldValue) {
    };
    return QueryColumn;
}());
export { QueryColumn };
//# sourceMappingURL=query_column.js.map